<script>
export default {

    methods: {

        getSpecificURL() {
            let src = '';
            if (window.location.href.indexOf('localhost') !== -1) {
                src = 'http://kta.ca.tagbleu.net/2022/K42000/K42423.humancom.livre.20.ans.appli.web.2022/05.out/catalogue/' + src;
            }
            else if (window.location.href.indexOf('kta.ca.tagbleu.net') !== -1) {
                src = 'http://kta.ca.tagbleu.net/2022/K42000/K42423.humancom.livre.20.ans.appli.web.2022/05.out/catalogue/' + src;
            }
            return src;
        },

        getRichmediaByCollection(page, collection) {
            let vm = this;
            let richmedia = page.richmedia || {};
            let slug = page.slug || '';
            let language = vm.$i18n.locale;


            let richmedia_collection = [];

            for (let idx_item in richmedia) {
                let item = richmedia[idx_item];

                let src = language + '/richmedia/' + slug + '/' + item.src;


                if (window.location.href.indexOf('localhost') !== -1) {
                    src = 'http://kta.ca.tagbleu.net/2022/K42000/K42423.humancom.livre.20.ans.appli.web.2022/05.out/catalogue/' + src;
                }
                else if (window.location.href.indexOf('kta.ca.tagbleu.net') !== -1) {
                    src = 'http://kta.ca.tagbleu.net/2022/K42000/K42423.humancom.livre.20.ans.appli.web.2022/05.out/catalogue/' + src;
                }

                let type = item.type;
                let caption = item.title;
                let thumb = item.thumb || src;
                let colorIcon = item.colorIcon
                let positionIcon = item.positionIcon

                switch (type) {
                    case 'html5video':
                        type = "html5video";
                        thumb = item.thumb || 'images/commons/thumb_video.png';
                        colorIcon = item.colorIcon;
                        positionIcon = item.positionIcon;
                        break;
                    case 'pdf':
                        type = "iframe";
                        thumb = item.thumb || 'images/commons/thumb_document.png';
                        src = language + '/richmedia/' + slug + '/' + item.src;
                        src = "libs/pdfjs-2.2.228/web/viewer.html?file=../../../" + src;
                        colorIcon = item.colorIcon;
                        positionIcon = item.positionIcon;
                        break;
                    case 'image':
                        thumb = src;
                        colorIcon = item.colorIcon;
                        positionIcon = item.positionIcon;
                        break;
                    case 'audio':
                        thumb = item.thumb || 'images/commons/thumb_audio.png';
                        break;
                    case 'link':
                        thumb = item.thumb || 'images/commons/thumb_link.png';
                        src = item.src;
                        colorIcon = item.colorIcon;
                        positionIcon = item.positionIcon;
                        break;
                    default:
                        break;
                }


                if (!collection) {
                    richmedia_collection.push({
                        src, type, caption, thumb, colorIcon, positionIcon
                    });
                } else if (collection === item.collection) {
                    richmedia_collection.push({
                      src, type, caption, thumb, colorIcon, positionIcon
                    });
                }
            }

            // console.log('richmedia_collection', richmedia_collection);

            return richmedia_collection;
        },

        getCollectionsNameFromRichmediaOfPage(page) {
            let richmedia = page.richmedia || {};

            let richmedia_collection = [];
            for (let idx_item in richmedia) {
                let item = richmedia[idx_item];
                richmedia_collection.push(item.collection || null);
            }

            return richmedia_collection.filter((v, i, a) => {
                return a.indexOf(v) === i
            })
        },

        richmediaShowDiaporama(resources) {
            Fancybox.show(
                    resources,
                    {
                        mainClass: "richmedia-diaporama",
                        Hash: false,
                        infinite: false,
                        Toolbar: {
                            display: [
                                'close',
                            ]
                        },

                        Image: {
                            zoom: false,

                        },
                        Html: {
                            video: {
                                autoplay: false,
                            },
                            html5video: {
                                tpl: `
                                    <video class="fancybox__html5video" playsinline controls controlsList="nodownload" _poster="{{poster}}">
                                        <source src="{{src}}" type="{{format}}" />
                                        Sorry, your browser doesn\'t support embedded videos, <a href="{{src}}">download</a> and watch with your favorite video player!
                                    </video>`,
                                format: "mp4",
                            }

                        },

                        on: {
                            reveal: function (fancybox, slide) {
                                let caption = slide.$el.querySelector('.fancybox__caption');
                                if (caption) {
                                    let content = slide.$el.querySelector('.fancybox__content');
                                    content.append(caption);
                                }
                                
                            },
                        },
                        
                    }
            )
        },

        getChapterPages(page, pages) {
            let summaryList = this.$application[this.$i18n.locale].summary.getAll();
            let pagesList = [];

            for (let summary of summaryList) {
                let pagesCollection = summary.pages || [];
                if (pagesCollection.indexOf(page.slug) !== -1) {
                    for (let slug of summary.pages) {
                        pagesList.push(pages.getBySlug(slug));
                    }
                }

            }
            return pagesList
        }
    },
}
</script>
